import { useEffect } from 'react';

const APP_NAME = 'energydash';

/**
 * Per-route document title. Every top-level page calls this on mount.
 *
 *   usePageTitle('Records');   // -> "energydash — Records"
 */
export function usePageTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${APP_NAME} — ${title}` : APP_NAME;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
